import FutureCareAgeYearCell from './FutureCareAgeYearCell';
import { formatCurrency } from '../../utils/lifecarePlanUtils';
import useFutureCareTable from '../../hooks/useFutureCareTable';

const titleClasses = 'text-base font-bold text-content m-0 mb-1';

const contentClasses = 'text-base leading-relaxed text-content whitespace-pre-line m-0 mb-2';

const tableClasses = 'w-full border-collapse text-sm mt-2';

const thClasses = 'text-left font-bold text-content border-b border-border py-1.5 px-2';

const tdClasses = 'text-content border-b border-border-light py-1.5 px-2 align-top';

const subtotalRowClasses = 'font-bold text-content';

const FutureCareTable = ({ subsection }) => {
    const { rows, subtotal } = useFutureCareTable({ subsection });

    return (
        <div className="mb-5">
            <p className={titleClasses}>{subsection.title}</p>
            {subsection.content && <p className={contentClasses}>{subsection.content}</p>}
            <table className={tableClasses}>
                <thead>
                    <tr>
                        <th className={thClasses}>Service / Item</th>
                        <th className={thClasses}>Age / Year</th>
                        <th className={thClasses}>Frequency</th>
                        <th className={thClasses}>Unit Cost</th>
                        <th className={thClasses}>Lifetime Cost</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => (
                        <tr key={`${subsection.title}-${index}`}>
                            <td className={tdClasses}>{row.item}</td>
                            <td className={tdClasses}>
                                <FutureCareAgeYearCell row={row} />
                            </td>
                            <td className={tdClasses}>{row.frequencyComment || row.frequencyPerYear}</td>
                            <td className={tdClasses}>{formatCurrency(row.unitCost)}</td>
                            <td className={tdClasses}>{formatCurrency(row.lifetimeCost)}</td>
                        </tr>
                    ))}
                    <tr className={subtotalRowClasses}>
                        <td className={tdClasses} colSpan={4}>
                            Subtotal
                        </td>
                        <td className={tdClasses}>{formatCurrency(subtotal)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default FutureCareTable;
